export interface TWorthyState {
  isWorthy: boolean
}

export enum ActionTypes {
  SET_IS_WORTHY = '@@isWorthy/SET_IS_WORTHY',
}
